<template>
  <div>
    <point-toolbar :point-info="point.name" />
    <v-container>
      <v-layout
        v-if="loading"
        justify-center
        align-center
        class="loading-indicator"
      >
        <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
        />
      </v-layout>
      <v-tabs
        v-if="!loading"
        color="accent-4"
        right
      >
        <span class="month-menu">
          <v-menu
            ref="monthMenu"
            v-model="monthSelectMenu"
            :close-on-content-click="false"
            :return-value.sync="monthDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="monthDate"
                label="Месяц потребления"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="monthDate"
              type="month"
              no-title
              scrollable
              locale="ru"
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="monthSelectMenu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="saveMonth"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </span>
        <v-spacer />
        <v-tab>
          <v-icon>
            mdi-table
          </v-icon>
        </v-tab>
        <v-tab>
          <v-icon>
            mdi-chart-bar
          </v-icon>
        </v-tab>

        <v-tab-item
          :key="1"
        >
          <v-data-table
            :headers="consumptionDataHeaders"
            :items="consumptionByDate"
            :items-per-page="32"
            fixed-header
            hide-default-footer
            no-data-text="Нет данных для отображения"
            height="80vh"
            dense
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.consumption_date }}</td>
                <td>{{ item.counter_serial_num }}</td>
                <td>{{ item.counter_value }}</td>
                <td>{{ item.consumption }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item
          :key="2"
        >
          <line-chart
            v-if="loaded"
            :chartdata="consumptionChartData"
            :options="consumptionChartOptions"
          />
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import PointToolbar from '../points/PointToolbar'
import LineChart from '../../shared-components/Chart'
import axios from 'axios'

export default {
  name: 'PointConsumption',
  components: {
    PointToolbar,
    LineChart
  },
  data () {
    return {
      pointId: this.$route.params['id'],
      loaded: true,
      point: { name: '' },
      consumptionChartData: null,
      consumptionChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      },
      consumptionDataHeaders: [
        {
          text: 'Дата',
          align: 'left',
          sortable: false,
          value: 'consumption_date'
        },
        {
          text: 'Номер счетчика',
          align: 'left',
          sortable: false,
          value: 'counter_serial_num'
        },
        {
          text: 'Показания',
          align: 'left',
          sortable: false,
          value: 'counter_value'
        },
        {
          text: 'Потребление',
          align: 'left',
          sortable: false,
          value: 'consumption'
        }
      ],
      consumptionByDate: [],
      monthDate: new Date().toISOString().substr(0, 7),
      monthSelectMenu: false
    }
  },
  watch: {},
  mounted () {
    this.getPointByDateConsumption()
    this.getPointApi()
  },
  methods: {
    getPointApi () {
      axios.get(`/api/points/${this.pointId}/`)
        .then((response) => {
          this.point = response.data
          this.loaded = true
        })
        .catch((err) => {
          this.loaded = true
          console.log(err)
        })
    },
    saveMonth () {
      this.$refs.monthMenu.save(this.monthDate)
      this.getPointByDateConsumption()
    },
    getPointByDateConsumption () {
      /**
       * Data of response contain
       * @param data.consumption_date
       * @param data.consumption
       */
      this.loaded = false
      axios.get(`/api/points/${this.pointId}/consumption_by_date/`,
        { params: { month: this.monthDate }})
        .then((response) => {
          this.consumptionByDate = response.data
          var consumptionDates = []
          var consumptionValues = []
          for (var v of this.consumptionByDate) {
            consumptionDates.push(v.consumption_date)
            consumptionValues.push(v.consumption)
          }
          this.consumptionChartData = {
            labels: consumptionDates,
            datasets: [
              {
                label: 'Потребление',
                backgroundColor: '#f87979',
                data: consumptionValues
              }
            ]
          }
          this.loaded = true
        })
        .catch((err) => {
          this.loaded = true
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .month-menu {
    width: 200px
  }
</style>



// WEBPACK FOOTER //
// src/spa/points/PointConsumption.vue